/**
 * SwitcherItem.tsx — element i switcher
 *
 * Ren React-komponent som erstatter cds-switcher-item.
 *
 * To moduser:
 * - Med `href`: rendres som next/link-lenke (navigasjon)
 * - Uten `href`: rendres som knapp (valg-handling, f.eks. bytt forhandler)
 *
 * Props:
 * - href (valgfri): rute-lenke. Utelates → rendres som knapp.
 * - onClick (valgfri): klikk-handler (brukes i knapp-modus)
 * - active (valgfri): markerer elementet som aktivt (aktiv-symbol)
 * - children: lenke-/knappetekst
 */

import Link from 'next/link';
import styles from './switcher-item.module.css';

interface SwitcherItemProps {
  href?: string;
  onClick?: () => void;
  active?: boolean;
  children: React.ReactNode;
}

export default function SwitcherItem({ href, onClick, active, children }: SwitcherItemProps) {
  // Knapp-modus: ingen href → valg-handling i stedet for navigasjon
  if (!href) {
    return (
      <li className={styles.item}>
        <button
          type="button"
          className={`${styles.link} ${active ? styles.active : ''}`}
          onClick={onClick}
        >
          {children}
          {active && (
            <span className={styles.activeDot} aria-label="Aktiv forhandler" />
          )}
        </button>
      </li>
    );
  }

  return (
    <li className={styles.item}>
      <Link href={href} className={styles.link}>
        {children}
      </Link>
    </li>
  );
}
